module.exports = __webpack_public_path__ + "4b6da798917c9aa5e8715d8460f9e878.svg";